import { useState } from "react";
import { Link } from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import MenuIcon from "@mui/icons-material/Menu";

const categories = [
  { id: "varak-baski", title: "Varak Baskı" },
  { id: "kabartma-baski", title: "Kabartma Baskı" },
  { id: "flok-baski", title: "Flok Baskı" },
  { id: "sim-baski", title: "Sim Baskı" },
  { id: "pvc-baski", title: "PVC Baskı" },
  { id: "pigment-baski", title: "Pigment Baskı" },
];

function Navbar() {
  const [anchorEl, setAnchorEl] = useState(null);
  const [mobileMenuAnchor, setMobileMenuAnchor] = useState(null);

  const handleCategoryClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClick = (event) => {
    setMobileMenuAnchor(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setMobileMenuAnchor(null);
  };

  return (
    <AppBar position="static">
      <Toolbar>
        <Typography
          variant="h6"
          component={Link}
          to="/"
          sx={{ flexGrow: 1, textDecoration: "none", color: "white" }}
        >
          ANKA BASKI
        </Typography>

        {/* Mobil menü */}
        <Box sx={{ display: { xs: "flex", md: "none" } }}>
          <IconButton color="inherit" onClick={handleMobileMenuClick}>
            <MenuIcon />
          </IconButton>
          <Menu
            anchorEl={mobileMenuAnchor}
            open={Boolean(mobileMenuAnchor)}
            onClose={handleClose}
          >
            <MenuItem component={Link} to="/" onClick={handleClose}>
              Ana Sayfa
            </MenuItem>
            <MenuItem component={Link} to="/about" onClick={handleClose}>
              Hakkımızda
            </MenuItem>
            <MenuItem onClick={handleCategoryClick}>Kategoriler</MenuItem>
          </Menu>
        </Box>

        {/* Desktop menü */}
        <Box sx={{ display: { xs: "none", md: "flex" } }}>
          <Button color="inherit" component={Link} to="/">
            Ana Sayfa
          </Button>
          <Button color="inherit" component={Link} to="/about">
            Hakkımızda
          </Button>
          <Button color="inherit" onClick={handleCategoryClick}>
            Kategoriler
          </Button>
        </Box>

        {/* Kategoriler dropdown menüsü */}
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          {categories.map((category) => (
            <MenuItem
              key={category.id}
              component={Link}
              to={`/category/${category.id}`}
              onClick={handleClose}
            >
              {category.title}
            </MenuItem>
          ))}
        </Menu>
      </Toolbar>
    </AppBar>
  );
}

export default Navbar;
